module.exports = __webpack_public_path__ + "img/muscles-vue-dos.9bf1bb1c.png";